import React from 'react';
import {observer} from 'mobx-react';
import {Title} from '@priority-software/priority-style-react';
import {formsStore} from '../../../_legacy/Form/stores/FormsStore';
import {getCurrentEntity} from '../../../_shared/GWTBridge/invoke/genPage';
import {createNewRow} from '../../../_shared/GWTBridge/invoke/headerPanel';
import {getIsEmptyTable} from '../../../_shared/GWTBridge/invoke/formTable';
import emptyStateTexts from './texts';
import emptyState from '../../../images/emptyState.png';
import emptyStateAdd from '../../../images/emptyStateAdd.svg';
import {PromotionBlock} from '../../../_legacy/Searches/components/AISearch/parts/PromotionBlock/PromotionBlock';
import {NoRecordsToShow} from '../../../features/Form/components/EmptyState';
import {renderGeneratorNewState} from '../../../_legacy/Searches/renderGenerator';

export const EmptyState = observer(() => {
    const {searchesStore} = formsStore;

    const title = searchesStore.formSelected
        ? emptyStateTexts.noResults
        : emptyStateTexts.noRecords;
    const message = searchesStore.formSelected ? (
        emptyStateTexts.moreResultsMessage
    ) : (
        <NoRecordsToShow createNewRow={createNewRow} />
    );
    const image = searchesStore.formSelected ? emptyState : emptyStateAdd;

    if (
        !searchesStore.emptyState ||
        !getCurrentEntity() ||
        (searchesStore.formSelected && !getIsEmptyTable())
    ) {
        return null;
    }

    return (
        <EmptyStateComponent
            title={title}
            message={message}
            image={image}
            openAISearch={() => renderGeneratorNewState({isAISearch: true})}
        />
    );
});

type size = 'small' | 'medium' | 'large';

interface EmptyStateProperties {
    image: string;
    title: string;
    children?: any;
    message: string | JSX.Element;
    size?: size;
    openAISearch?: () => void;
}

export function EmptyStateComponent(props: EmptyStateProperties) {
    const {title, message, image, openAISearch} = props;
    return (
        <div className="empty-state-container">
            <div className="empty-state-align">
                <div className="empty-state-hero">
                    <img src={image} alt="" />
                    <Title
                        skin="h2"
                        textColor="primary-500"
                        componentClasses={
                            formsStore?.searchesStore?.formSelected ? '' : 'empty-state-title'
                        }
                    >
                        {title}
                    </Title>
                </div>
                <div className="content">
                    {message}
                    <PromotionBlock
                        blockWrapperClass={'promoBlockWrapper'}
                        openAISearch={openAISearch}
                    />
                </div>
            </div>
        </div>
    );
}
